import React, { Component } from "react";
import ReactGA from "react-ga4";
export default class BuyTicket extends Component {
  constructor(props) {
    super(props);
    this.state = {
      buyTicketActive: false,
    };
    this.handleClick = this.handleClick.bind(this);
  }
  handleClick() {
    this.setState((prevState) => ({
      buyTicketActive: !prevState.buyTicketActive,
    }));
    /* ReactGA.event({
      category: "pysitellimus",
      action: "click",
      label: "buy ticket",
    });*/
  }
  render() {
    const { language } = this.props;
    return (
      <div
        className={`buyTicket ${
          this.state.buyTicketActive ? "buyTicket--active" : ""
        }`}
      >
        <a className="button button--red" onClick={() => this.handleClick()}>
          <div className="background"></div>
          {language === "et" ? (
            <span>TEEN&nbsp;TELLIMUSE</span>
          ) : (
            <span>Сделать&nbsp;заказ</span>
          )}
        </a>
        {this.state.buyTicketActive && (
          <div className="buyGames">
            <a
              href={`https://www.eestiloto.ee/${language}/bingoloto/?quicktipp=1&utm_source=campaignpage&utm_medium=text&utm_campaign=pysitellimus&utm_term=bingoloto`}
              target="_blank"
            >
              <img src={`./assets/images/bingo.svg`} alt="bingo" />
            </a>

            <a
              href={`https://www.eestiloto.ee/${language}/vikinglotto/?quicktipp=1&utm_source=campaignpage&utm_medium=text&utm_campaign=pysitellimus&utm_term=vikinglotto`}
              target="_blank"
            >
              <img src={`./assets/images/vikinglotto.svg`} alt="Vikinglotto" />
            </a>

            <a
              href={`https://www.eestiloto.ee/${language}/eurojackpot/?quicktipp=1&utm_source=campaignpage&utm_medium=text&utm_campaign=pysitellimus&utm_term=eurojackpot`}
              target="_blank"
            >
              <img src={`./assets/images/eurojackpot.svg`} alt="Eurojackpot" />
            </a>

            <a
              href={`https://www.eestiloto.ee/${language}/keno/?quicktipp=1&utm_source=campaignpage&utm_medium=text&utm_campaign=pysitellimus&utm_term=keno`}
              target="_blank"
            >
              <img src={`./assets/images/keno.svg`} alt="Keno" />
            </a>
            <a
              href={`https://www.eestiloto.ee/${language}/jokker/?quicktipp=1&utm_source=campaignpage&utm_medium=text&utm_campaign=pysitellimus&utm_term=jokker`}
              target="_blank"
            >
              <img src={`./assets/images/jokker.svg`} alt="Jokker" />
            </a>
          </div>
        )}
      </div>
    );
  }
}
